import { Fragment, useEffect, useState } from "react";
import Header from "../common/Header";
import {  useForm } from "./../context/FormContext";
import Footer from "../common/Footer";
import { Box, Button, Modal, Typography, FormControlLabel, CircularProgress } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import KioskForm from "./Kiosk/KioskForm";
import LockerForm from "./Locker/LockerForm";
import ParcelPointForm from "./ParcelPoint/ParcelPointForm";
import DoorForm from "./Door/DoorForm";
import Summary from './Summary';
import { useNavigate } from "react-router";
import SelectedServices from "./SelectedServices";
import { pickup_services } from './../data'
import submitParcel from './../api/parcel';
import sendWhatsappNotification from '../api/sendWhatsappNotification';
import axiosInstance from "./../api/axiosConfig";

const ServiceSwitch =  ({ type }) => {
    let navigate = useNavigate();
    const { formData, updateField,validateForm, errors } = useForm();
    const [returnData, setReturnData] = useState({})
    const [serviceDeliveryError, setServiceDeliveryError] = useState('')
    const [submitError, setsubmitError] = useState(false)
    const [modalOpen, setModalOpen] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [loadingSubmit, setloadingSubmit] = useState(false);
   
    useEffect(() => {
        window.scrollTo(0, 0);
        updateField('service_type',type);
    }, []);
    
    const handleBack = (event) => {
        event.preventDefault();
        const type_data = (type.includes('pp_')) ? 'pp' : '';
        if(currentStep === 0 ){
            navigate(`/${type_data}`)
        } else {
            if (currentStep > 0) {
                setCurrentStep((prev) => prev - 1);
                window.scrollTo(0, 0);
            }
        }

    }

    const submitDelivery = async (url, parameter) => {
        try {
            setloadingSubmit(true)
            const response = (type.includes('pp_')) ? await submitParcel(parameter) : await axiosInstance.post(url, parameter);
            if(!type.includes('pp_')){
                sendWhatsappNotification({ waybill: response?.data?.short_tracking_reference, mobile: formData?.senderNumber });
            } 
           
            setReturnData((type.includes('pp_')) ? response : response.data);
            setsubmitError(false);
            setloadingSubmit(false)
        } catch (err) {
            setloadingSubmit(false)
            setsubmitError(true);
            setServiceDeliveryError(err)
        } finally {
            setModalOpen(true);
            setloadingSubmit(false)
        }
    }

    const handleSubmitForm = (event) => {
        event.preventDefault();
       
        let today = new Date();
        today.setDate(today.getDate() + 5);
       
        if (validateForm()) {
            if(currentStep === 1){
                const collection_address_type = (type.includes('kiosk_')) ? 'kiosk' : ((type.includes('pp_')) ? 'pickup point' : 'locker');
                if(type.includes('pp_')){
                    const parameter = {
                        collection_address: type.includes('pp_') ? {
                            type: collection_address_type,
                        } : {
                            type: "counter",
                            company: "Kiosk Pre-Booking [Change to your cash account]",
                            street_address: "Pre Booking",
                            local_area: "Pre Booking",
                            city: "Pre Booking",
                            code: "0000",
                            zone: "Gauteng",
                            country: "ZA",
                            lat: -26.004105079236897,
                            lng: 27.940885290245756,
                        },
                        collection_contact: {
                            name: formData?.senderName,
                            email: formData?.senderEmail,
                            mobile_number: formData?.senderNumber
                        },
                        delivery_contact: {
                            name: formData?.receiverName,
                            email: formData?.receiverEmail,
                            mobile_number: formData?.receiverNumber
                        },
                        
                        status: "payment-pending",
                        platform: "in-store",
                        deliveryInstruction:formData?.deliveryInstruction??"",
                        special_instructions_collection: "None",
                        special_instructions_delivery: "",
                        service_level_code: type.includes('pp_') ? formData.parcelPrice : "ECO",
                        delivery_address: type.includes('_door') ? {
                            company: formData?.companyName,
                            street_address: formData?.streetAddress,
                            local_area: formData?.suburb,
                            suburb: formData?.suburb,
                            city: formData?.city,
                            code: formData?.postCode,
                            zone: formData?.province.id,
                            country: "South Africa",
                            type: formData?.addressType ?? "residential"
                        } : {
                            terminal_id: formData.selectedLocker.lockerId
                        }
                    }
                    submitDelivery("shipments",parameter);
                } else {
                    const parameter = {
                        collection_address: type.includes('pp_') ? {
                            type: collection_address_type,
                        } : {
                            type: "counter",
                            company: "Kiosk Pre-Booking [Change to your cash account]",
                            street_address: "Pre Booking",
                            local_area: "Pre Booking",
                            city: "Pre Booking",
                            code: "0000",
                            zone: "Gauteng",
                            country: "ZA",
                            lat: -26.004105079236897,
                            lng: 27.940885290245756,
                        },
                        collection_contact: {
                            name: formData?.senderName,
                            email: formData?.senderEmail,
                            mobile_number: formData?.senderNumber
                        },
                        delivery_contact: {
                            name: formData?.receiverName,
                            email: formData?.receiverEmail,
                            mobile_number: formData?.receiverNumber
                        },
                        status: "payment-pending",
                        special_instructions_delivery:formData?.deliveryInstruction,
                        special_instructions_collection: "",
                        service_level_code: type.includes('pp_') ? formData.parcelPrice : "ECO",
                        delivery_address: type.includes('_door') ? {
                            company: formData?.companyName,
                            street_address: formData?.streetAddress,
                            local_area: formData?.suburb,
                            suburb: formData?.suburb,
                            city: formData?.city,
                            code: formData?.postCode,
                            zone: formData?.province.id,
                            country: "South Africa",
                            type: formData?.addressType
                        } : {
                            company: formData?.selectedLocker?.name,
                            street_address: formData?.selectedLocker?.address.address,
                            local_area: "",
                            suburb: "",
                            city: "",
                            code: formData?.selectedLocker?.address.postal_code,
                            zone: "",
                            country: "South Africa",
                            lat:formData?.selectedLocker?.address.latitude,
                            lng:formData?.selectedLocker?.address.longitude,
                            type: (type.includes('_locker')) ? 'locker' : 'counter'
                        },
                        collection_min_date: `${today.toISOString()}`,
                        collection_after: "08:00",
                        collection_before: "18:00",
                        mute_notifications: true,
                        declared_value: 0,
                        custom_tracking_reference: "",
                        parcels: [
                            {
                            parcel_description: "",
                            submitted_length_cm: 1,
                            submitted_width_cm: 1,
                            submitted_height_cm: 1,
                            submitted_weight_kg: 1,
                            },
                        ],
                    }
                    
                    submitDelivery("shipments",parameter);
                }
                  
            } else {
                setCurrentStep((prev) => prev + 1);
            }
        } else {
            console.log(errors);
        }
    }

    const closeModal = () => {
        setModalOpen(false);
        if (submitError === false) {
            let redirect_to = type.includes('pp_') ? 'pp' : '';
            navigate(`/${redirect_to}`);
        }
    };

    return <Fragment>
        <Header />
        <main className="flex-1 pt-24 pb-16">
            <div className="max-w-7xl m-auto px-4 md:px-16">
                <div style={{ margin: "2vh" }} />
                <form onSubmit={(e) => handleSubmitForm(e)}>
                    <div style={{ margin: "3vh" }} />
                    <SelectedServices selected_dropoff={type.split("_to_")[0]} selected_pickup={type.split("_to_")[1]} selected_service={pickup_services.filter(value => value.value === type.split("_to_")[1])} />
                    <div style={{ margin: "3vh" }} />
                    { (currentStep === 0) ? renderServiceForm(type, formData) : <Summary type={type} data={formData}  /> }
                    <div style={{ margin: "3vh" }} />
                    {
                            (currentStep === 1) ? (
                                <Box>
                                    <FormControlLabel
                                        xs={{
                                            color: 'white'
                                        }}
                                        control={
                                            <Checkbox
                                                required
                                                checked={formData.accepted || false}
                                                onChange={(e) => updateField('accepted', e.target.checked)}
                                                color="primary"
                                            />
                                        }
                                        label="I have read and agree with the terms and conditions"
                                    />
                                </Box>
                            ) : null
                            
                        
                    }
                    
                    <div className="flex justify-end">
                        <button onClick={(e) => handleBack(e)} className="border-[#2B549A] border rounded-md px-16 py-2 hover:bg-[#2B549A] hover:text-white"> Back </button>
                        <button disabled={(loadingSubmit === false) ? false : true} type="submit" className="bg-[#2B549A] border-[#2B549A] border rounded-md px-16 py-[6.5px]  text-white ml-2">
                            {(loadingSubmit) ? <CircularProgress size="15px" className="success" color="primary" /> :(currentStep === 1) ? 'Submit' : 'Next'}
                        </button>    
                    </div>
                </form>
            </div>
        </main>
        <Footer />

        <Modal
            open={modalOpen}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                }}
            >
                {(submitError === false) ?
                    (
                        <div>
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Thank you for your booking:
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Your Reference # is {(type.includes('pp_')) ? returnData.custom_tracking_reference : returnData.short_tracking_reference}
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                You will shortly receive a WhatsApp notification confirming your waybill #
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                You will be redirected to homepage after clicking the close button.
                            </Typography>
                        </div>
                    ) : (
                        <div>
                            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ color: 'red', mb: 2 }}>
                                Error: {serviceDeliveryError.message}
                            </Typography>
                        </div>
                    )
                }
                
                <Button onClick={closeModal}>Close</Button>
            </Box>
        </Modal>
    </Fragment>
}

const renderServiceForm = (type, formData = {}) => {
    switch (type) {
        case "pp_to_locker":
        case "kiosk_to_locker":
            return <LockerForm type={type} />;
        case "pp_to_kiosk":
        case "kiosk_to_kiosk":
            return <KioskForm type={type} />;
        case "pp_to_pp":
        case "kiosk_to_pp":
            return <ParcelPointForm type={type} />;
        case "pp_to_door":
        case "kiosk_to_door":
            return <DoorForm type={type} data={formData}/>;
        default:
            return null;
    }
}

export default ServiceSwitch;